import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

function AdminEmailPage() {
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager />
    </PageContainer>
  );
}

export const adminEmailRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email",
  // Editor de plantilla direccionable (#15b D15/D16): `?compose=new` (crear) o
  // `?tpl=<id>` (editar). Reabre exacto al recargar/compartir.
  validateSearch: (search: Record<string, unknown>): { compose?: "new"; tpl?: string } => ({
    compose: search.compose === "new" ? "new" : undefined,
    tpl: typeof search.tpl === "string" && search.tpl.trim() !== "" ? search.tpl : undefined,
  }),
  component: AdminEmailPage,
});
